import Request from 'utils/request.js';

const MANAGEMENT_BASE_URL = 'management/carousel-items';
const STORE_BASE_URL = 'store/carousel-items';

// Store
export const getCarouselItems = () => Request.get(`${STORE_BASE_URL}`);

// Helpers
const toFormData = (data = {}) => {
  const form = new FormData();
  if (data.description != null) form.append('description', data.description);
  if (data.link != null) form.append('link', data.link);
  if (typeof data.active !== 'undefined') form.append('active', String(Boolean(data.active)));
  if (data.image instanceof File) form.append('image', data.image); // campo esperado pelo backend
  return form;
};

// Management (multipart/form-data)
export const carouselItemsCreate = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const carouselItemsUpdate = (id, data) =>
  Request.put(`${MANAGEMENT_BASE_URL}/${id}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const carouselItemsDelete = (id) => Request.delete(`${MANAGEMENT_BASE_URL}/${id}`);
export const carouselItemsUpdateOrders = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}/:update-orders`, data);
